<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Subcategoría') "
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_subcategory', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="subcategoria"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="colOptions" :label="$t('Fecha de inicio') ">
                <a-date-picker style="width: 100%"
                               type="date"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['init_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="colOptions" :label="$t('Fecha de fin') ">
                <a-date-picker style="width: 100%"
                               type="date"
                               valueFormat="Y-MM-DD HH:mm:ss"
                               v-decorator="['end_date', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        iEmpCategory: {},
        formRules: {},
        loading: false,
        subcategoria: {h_lookup_type: 'SUBCATEGORIA_GRUPOSALARIAL'},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'emp_category',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_emp_cat'
            },
            columns: [
              {title: 'Subcategoría', dataIndex: 'subcategoria', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'fecha_inicio', sorter: true},
              {title: 'Fecha fin', dataIndex: 'fecha_fin', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_subcategory'},
            {name: 'init_date'},
            {name: 'end_date'},
            {name: 'status'}
          ]
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeEmpCategory.vue